import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './css/TodayOrder.css';

import axiosRestaurantInstance from './AxiosRestaurantInstance';
// import { messaging,onMessage } from "./Firebase"
const TodayOrder = () => {
    const [restaurants, setRestaurants] = useState([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState('');
    const [orders, setOrders] = useState([]);
    const [selectedOrderItems, setSelectedOrderItems] = useState(null);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [currentOrderId, setCurrentOrderId] = useState(null);
    const [deliveryAgents, setDeliveryAgents] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [assignedAgents, setAssignedAgents] = useState({}); 



    const navigate = useNavigate();

    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user ? user.userId : null;

    useEffect(() => {
        const fetchRestaurants = async () => {
            if (!userId) {
                console.error('User ID is not available');
                return;
            }
    
            try {
                const response = await axiosRestaurantInstance.get(`/user_restaurant/${userId}`);
                setRestaurants(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error('Error fetching restaurants:', error.response?.data || error.message);
            }
        };
    
        const fetchOrders = async (restaurantId) => {
            try {
                const token = localStorage.getItem('Token');
                const response = await axiosRestaurantInstance.get(`/get_orders_all/${restaurantId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`, // Set the token in the Authorization header
                    },
                });
        
                const sortedOrders = (response.data.orders || []).sort(
                    (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
                );
        
                // Map orders and initialize assignedAgents state with fetched data
                const initialAssignedAgents = {};
                sortedOrders.forEach(order => {
                    if (order.deliveryContactName) {
                        initialAssignedAgents[order.orderId] = order.deliveryContactName;
                    }
                });
        
                setOrders(sortedOrders);
                setAssignedAgents(initialAssignedAgents); // Store initial assignments
            } catch (error) {
                console.error('Error fetching orders:', error.response?.data || error.message);
            }
        };
        
    
        // Fetch restaurants once on component mount
        fetchRestaurants();
    
        // Fetch orders only when a restaurant is selected
        if (selectedRestaurant) {
            fetchOrders(selectedRestaurant);
        }
    }, [userId, selectedRestaurant]);
    

const fetchOrders = async (restaurantId) => {
    try {
        const token = localStorage.getItem('Token')
        const response = await axiosRestaurantInstance.get(`/get_orders_all/${restaurantId}`,{
            headers: {
                'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
            }
        });
    //     console.log('hiiiii')
    // //   await  trigger();
    //     console.log('Trigger');
        const sortedOrders = (response.data.orders || []).sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
        setOrders(sortedOrders);
    } catch (error) {
        console.error('Error fetching orders:', error.response?.data || error.message);
    }
};

const fetchDeliveryAgents = async () => {
    try {
        const token = localStorage.getItem('Token')
        const response = await axiosRestaurantInstance.get('/get_users_by_role',{
            headers: {
                'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
            }
        });
        setDeliveryAgents(response.data.users || []);
    } catch (error) {
        console.error('Error fetching delivery agents:', error.response?.data || error.message);
    }
};

const handleSelectChange = (event) => {
    const restaurantId = event.target.value;
    setSelectedRestaurant(restaurantId);
    if (restaurantId) {
        fetchOrders(restaurantId);
    } else {
        setOrders([]);
    }
};

const handleAssignAgent = async (agentId) => {
    const selectedAgent = deliveryAgents.find((agent) => agent.userId === agentId);

    if (selectedAgent) {
        const updatedData = {
            delivery_contact_name: selectedAgent.userName,
            delivery_contact_no: selectedAgent.mobile,
        };

        try {
            const token = localStorage.getItem('Token');
            const response = await axiosRestaurantInstance.put(
                `/update_order/${currentOrderId}`,
                updatedData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            console.log(response.data.message);

            // Update the local state for the assigned agent
            setAssignedAgents((prev) => ({
                ...prev,
                [currentOrderId]: selectedAgent.userName,
            }));

            // Update the specific order in the state
            setOrders((prevOrders) =>
                prevOrders.map((order) =>
                    order.orderId === currentOrderId
                        ? {
                            ...order,
                            deliveryContactName: selectedAgent.userName,
                            deliveryContactNo: selectedAgent.mobile,
                            orderStatus: 'IN-TRANSIT', // Update status to reflect assignment
                        }
                        : order
                )
            );

            setIsPopupVisible(false); // Close the popup
        } catch (error) {
            console.error('Error assigning delivery agent:', error.response?.data || error.message);
        }
    }
};

const handleActionClick = async (orderId, action) => {
    if (action === "confirm") {
        setIsPopupVisible(true);
        setCurrentOrderId(orderId);
        await fetchDeliveryAgents();
    } else if (action === "cancel") {
        const confirmCancel = window.confirm("Do you really want to cancel this order?");
        if (confirmCancel) {
            await handleCancelOrder(orderId);
        }
    }
};

const handleCancelOrder = async (orderId) => {
    try {
        const token = localStorage.getItem('Token');

        const response = await axiosRestaurantInstance.put(
            `/cancel/${orderId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        console.log(response.data.message);

        // Update the specific order in the state
        setOrders((prevOrders) =>
            prevOrders.map((order) =>
                order.orderId === orderId
                    ? { ...order, orderStatus: 'CANCELLED' }
                    : order
            )
        );
    } catch (error) {
        console.error('Error cancelling order:', error.response?.data || error.message);
    }
};



    const handleClosePopup = () => {
        setIsPopupVisible(false);
    };

    const handleFoodItemsClick = (order) => {
        setSelectedOrderItems(selectedOrderItems === order.orderId ? null : order.orderId);
    };

    const handleOrderIdClick = (orderId) => {
        const token = localStorage.getItem('Token')
        navigate(`/OrderDetails/${selectedRestaurant}/${orderId}`,{
            headers: {
                'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
            }
        });
    };

    const handleAgentClick = (orderId) => {
        setCurrentOrderId(orderId);
        fetchDeliveryAgents();
        setIsPopupVisible(true);
    };

    const filteredOrders = orders.filter(order => order.orderStatus !== 'CANCELLED' && order.orderStatus !== 'DELIVERED');

    const filteredAgents = deliveryAgents.filter(agent =>
        agent.userName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        agent.mobile.includes(searchQuery)
    );

    return (
        <div>
            <h1 className="today-order-heading">Select a restaurant</h1>
            <select
                className="today-order-select"
                value={selectedRestaurant}
                onChange={handleSelectChange}
            >
                <option value="">-- Select a restaurant --</option>
                {restaurants.length > 0 ? (
                    restaurants.map((restaurant) => (
                        <option key={restaurant.RestaurantId} value={restaurant.RestaurantId}>
                            {restaurant.RestaurantName}
                        </option>
                    ))
                ) : (
                    <option disabled>No restaurants available</option>
                )}
            </select>
    
            {filteredOrders.length > 0 && (
                <table className="today-order-table">
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Customer Name</th>
                            <th>Total Price</th>
                            <th>Order Status</th>
                            <th>Created Date</th>
                            <th>Food Items</th>
                            <th>organization Name</th>
                            <th>Receiver Name</th>
                            <th>Assigned Agent</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOrders.map((order) => (
                            <React.Fragment key={order.orderId}>
                                <tr>
                                    <td
                                        className="today-order-clickable"
                                        onClick={() => handleOrderIdClick(order.orderId)}
                                    >
                                        {order.orderId}
                                    </td>
                                    <td>{order.customerName}</td>
                                    <td>{order.totalPrice}</td>
                                    <td>{order.orderStatus}</td>
                                    <td>{order.createdDate}</td>
                                    <td>
                                        <span
                                            className="today-order-clickable"
                                            onClick={() => handleFoodItemsClick(order)}
                                        >
                                            {order.OrderLineItems.length > 0
                                                ? 'View Food Items'
                                                : 'No food items'}
                                        </span>
                                    </td>
                                    <td>{order.organizationName}</td>
                                    <td>{order.receiverName}</td>
                                    <td>
                                        {assignedAgents[order.orderId]
                                            ? `Assigned - ${assignedAgents[order.orderId]}`
                                            : 'Not assigned'}
                                    </td>
                                    <td>
                                        {order.orderStatus === 'NEW' ? (
                                            <>
                                                <button
                                                    className="today-order-button"
                                                    onClick={() =>
                                                        handleActionClick(order.orderId, 'confirm')
                                                    }
                                                >
                                                    Confirm
                                                </button>
                                                <button
                                                    className="today-order-button"
                                                    onClick={() =>
                                                        handleActionClick(order.orderId, 'cancel')
                                                    }
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        ) : order.orderStatus === 'IN-TRANSIT' ? (
                                            <>
                                                <button
                                                    className="today-order-button"
                                                    onClick={() => handleAgentClick(order.orderId)}
                                                >
                                                    Update
                                                </button>
                                                <button
                                                    className="today-order-button"
                                                    onClick={() =>
                                                        handleActionClick(order.orderId, 'cancel')
                                                    }
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        ) : null}
                                    </td>
                                </tr>
                                {selectedOrderItems === order.orderId && (
                                    <tr>
                                        <td colSpan="10">
                                            <ul className="today-order-food-list">
                                                {order.OrderLineItems.map((item) => (
                                                    <li key={item.orderLineId}>
                                                        {item.foodItemName} - Quantity: {item.foodQuantity}
                                                        , Price: {item.price}
                                                    </li>
                                                ))}
                                            </ul>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            )}
    
            {isPopupVisible && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <button className="close-popup-button" onClick={handleClosePopup}>
                            X
                        </button>
                        <h2>Assign Delivery Agent</h2>
                        <input
                            type="text"
                            className="agent-search-box"
                            placeholder="Search by name or phone number"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <table className="delivery-agents-table">
                            <thead>
                                <tr>
                                    <th>Agent Name</th>
                                    <th>Phone Number</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredAgents.length > 0 ? (
                                    filteredAgents.map((agent) => (
                                        <tr key={agent.userId}>
                                            <td>{agent.userName}</td>
                                            <td>{agent.mobile}</td>
                                            <td>
                                                <button
                                                    className="assign-agent-button"
                                                    onClick={() => handleAssignAgent(agent.userId)}
                                                >
                                                    Assign
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">No matching agents found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};    
export default TodayOrder;
